export default __webpack_public_path__ + "static/media/news5.8f9ae124.png";